import React from 'react';
import { isArray, isString } from 'lodash';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import styles from './DividedColumnDetails.styles';
import { classes } from 'typestyle';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import { ErrorIcon } from 'src/common-ui/components/Inputs/InputSuggest/InputSuggest';
import { getChipStyles } from 'src/common-ui/components/Inputs/InputSuggest/InputSuggest.styles';
import { Chip } from '@material-ui/core';
import { DividedColumnDetailsSectionInputParams } from './DividedColumnDetails.types';

interface DividedColumnDetailsDropdownRendererProps {
  displayValue: string | string[];
  inputParams?: DividedColumnDetailsSectionInputParams;
  isDisabled: boolean;
  isInvalid: boolean;
  id: string;
  onClick: (rendererKey: string) => void;
  tooltip: string | JSX.Element;
}

export const DividedColumnDetailsDropdownRenderer = ({
  displayValue,
  inputParams,
  isDisabled,
  isInvalid,
  id,
  onClick,
  tooltip,
}: DividedColumnDetailsDropdownRendererProps) => {
  let content = null; // need a starting value;

  if (isString(displayValue)) {
    // single select dropdown
    content = (
      <span style={{ fontSize: '0.8rem' }} className={classes(displayValue ? styles.dataText : styles.fakePlaceholder)}>
        {displayValue || 'Select...'}
      </span>
    );
  } else if (displayValue.length > 0) {
    // show multiselect selection labels
    content = (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
        {displayValue.map((dv, index) => {
          return (
            <Chip
              key={index}
              className="s5-MuiAutocomplete-tag"
              classes={{ ...getChipStyles({ fullWidth: true }) }}
              label={dv}
              size="small"
            />
          );
        })}
      </div>
    );
  } else {
    // empty renderer
    content = (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>Search...</span>
      </div>
    );
  }

  return (
    <Tooltip
      style={{ marginBottom: 8 }}
      className={styles.dataItem}
      data-qa="fake-multiselect-tooltip"
      title={tooltip}
      placement="right"
    >
      <div
        style={{
          height: inputParams?.height,
          justifyContent:
            isString(displayValue) || (isArray(displayValue) && displayValue.length > 0) ? 'space-between' : 'flex-end',
        }}
        className={classes(styles.dataItem, styles.fakeDropdown)}
        aria-disabled={isDisabled}
        onClick={() => onClick(id)}
        data-qa="fake-dropdown-container"
      >
        {isInvalid && (
          <ErrorIcon label={String(displayValue)} value={displayValue} icon="fal fa-exclamation-triangle" />
        )}
        {content}
        <KeyboardArrowDownIcon style={{ height: '90%' }} className={styles.fakeIcon} />
      </div>
    </Tooltip>
  );
};
